import { FestivalButtons } from 'pages/custom/Festival/FestivalButtons';
import { CustomMapPage } from 'pages/custom/shared/CustomMapPage';
import { S_PageStyle } from 'pages/page/PageStyle';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const FestivalPageNO = (props: Props): JSX.Element => {
    return (
        <S_FjellseterPage className={props.className}>
            <CustomMapPage
                mapId={'cd8c0156-8034-4ab8-9af1-d5af72879483'}
                header={{
                    logo: 'https://dvtqxks0zalev.cloudfront.net/2c69e2d2-7c0c-4539-944f-b0577a21052e.png',
                    logoText: 'Festival demo',
                    logoSubtext: '20.6.2023',
                    linkText: 'Web',
                    link: 'https://mapheim.com/'
                }}
                mapChildren={<></>}
                controls={<FestivalButtons programeId="f61c47ee-b9e2-4f0e-95b1-285ac270794d" />}
            />
        </S_FjellseterPage>
    );
};

const S_FjellseterPage = styled(S_PageStyle)`
    display: flex;
    flex-direction: column;
    position: relative;
`;
